class AccordionItem {
  constructor({
    rootEl,
  } = {}) {
    this.rootEl = rootEl;
    this.status = false;

    this.toggleEl = rootEl.querySelector('[data-action="toggle-item"]');
    this.closeEl = rootEl.querySelector('[data-action="close-item"]');
    this.contentEl = rootEl.querySelector('.content');
    this.contentTabs = rootEl.querySelectorAll('.content__tab');
    this.contentSelectorButtons = rootEl.querySelectorAll('.content__buttons__item input');

    this.init();
  }

  updateDOM() {
    this.rootEl.setAttribute('aria-expanded', this.status);
    this.contentEl.setAttribute('aria-hidden', !this.status);
  }

  toggle() {
    this.status = !this.status;
    this.updateDOM();
  }

  close() {
    this.status = false;
    this.updateDOM();

    setTimeout(() => {
      this.toggleEl.focus();
    }, 200);
  }

  closeTabs() {
    [...this.contentTabs].forEach((tab) => {
      tab.setAttribute('aria-hidden', 'true');
    });
  }

  init() {
    const that = this;
    this.updateDOM();

    this.toggleEl.addEventListener('click', () => { that.toggle(); });
    this.toggleEl.addEventListener('keydown', (event) => {
      if (event.isComposing || event.keyCode === 229) {
        return;
      }

      if (event.code === 'Enter') {
        that.toggle();
      }
    });
    this.closeEl.addEventListener('click', () => { that.close(); });

    [...this.contentSelectorButtons].forEach((btn) => {
      btn.addEventListener('click', () => {
        that.closeTabs();
        const target = that.rootEl.querySelector(btn.getAttribute('aria-controls'));
        target.setAttribute('aria-hidden', 'false');
      });
    });
  }
}

export default AccordionItem;
